/* eslint-disable no-undef */
import { Coordinates } from '@volkswagen-onehub/audi-feature-service-visitor-locator';

export function placeDetails(placeId: string): Promise<Coordinates> {
  return new Promise<Coordinates>((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId }, (results, status) => {
      if (status !== 'OK') {
        return reject(new Error('Place details cannot be fetched'));
      }
      return resolve({
        lat: results[0].geometry.location.lat(),
        lng: results[0].geometry.location.lng(),
      });
    });
  });
}

export function regionDetails(country: string): Promise<google.maps.GeocoderResult[]> {
  return new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: country }, (results, status) => {
      if (status !== 'OK') {
        return reject(new Error('Region details cannot be fetched'));
      }
      return resolve(results);
    });
  });
}
